import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppComponent } from './app.component';
import { MapComponent } from './components/map/map.component';
import { GiswebComponent } from './components/gisweb/gisweb.component';
import { HeaderComponent } from './components/header/header.component';
import { ToolsMenuComponent } from './components/tools-menu/tools-menu.component';
import { LayerMenuComponent } from './components/layer-menu/layer-menu.component';
import { SearchComponent } from './components/search/search.component';
import { ThumbnailLayerComponent } from './components/thumbnail-layer/thumbnail-layer.component';
import { DrawControlComponent} from './components/tools/draw-control/draw-control.component';
import { ShareMapComponent} from './components/tools/share-map/share-map.component';
import { MeasureDistanceControlComponent} from './components/tools/measure-distance-control/measure-distance-control.component';
import { MeasureSurfaceControlComponent} from './components/tools/measure-surface-control/measure-surface-control.component';
import { PrintControlComponent} from './components/tools/print-control/print-control.component';
import { ThumbnailFilterPipe } from './filters/thumbnail-filter.pipe';
import { KeysPipe } from './filters/keys-filter.pipe';
import { MapService } from './services/map/map.service';
import { UrlParamsService } from './services/utils/url-params.service';
import { SearchService } from './services/search/search.service';
import { ShareButtonsModule } from 'ngx-sharebuttons';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ColorPickerModule } from 'angular4-color-picker';
import { Ng2CompleterModule } from "ng2-completer";
import { IdentifyControlComponent } from './components/tools/identify-control/identify-control.component';
import { LegendControlComponent } from './components/tools/legend-control/legend-control.component';
import { LoginModalComponent } from './components/login-modal/login-modal.component';
import { LoginService } from './services/login/login.service';
import { PrintLoadingComponent } from './components/print-loading/print-loading.component';
import { HighlightingFeaturesService } from './services/map/highlighting_features';
import { ModalComponent } from './components/modal/modal.component';
import { ModalService } from './services/modal/modal.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const appRoutes: Routes = [
    { path: '', component: GiswebComponent }
];

@NgModule({
    declarations: [
        AppComponent,
        GiswebComponent,
        ThumbnailLayerComponent,
        ThumbnailFilterPipe,
        KeysPipe,
        MapComponent,
        HeaderComponent,
        ToolsMenuComponent,
        LayerMenuComponent,
        SearchComponent,
        DrawControlComponent,
        ShareMapComponent,
        MeasureDistanceControlComponent,
        PrintControlComponent,
        MeasureSurfaceControlComponent,
        ModalComponent,
        IdentifyControlComponent,
        LegendControlComponent,
        LoginModalComponent,
        PrintLoadingComponent,
    ],
    imports: [
        RouterModule.forRoot(appRoutes),
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [Http]
            }
        }),
        ShareButtonsModule.forRoot(),
        ColorPickerModule,
        Ng2CompleterModule
    ],
    providers: [MapService, ModalService, UrlParamsService, Location, { provide: LocationStrategy, useClass: PathLocationStrategy }, SearchService, FormBuilder, LoginService, HighlightingFeaturesService],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/app.module.ts